/* Independent Saron product gallery controller */
(function () {
  function imageMatches(image, mediaId) {
    return image && image.getAttribute('data-media-id') === mediaId;
  }
  function setVisibleImage(container, thumb, mediaId) {
    const fullSrc = thumb.getAttribute('data-full-src');
    if (!fullSrc) return;
    let visibleSlide = container.querySelector('.swiper-slide-active');
    if (!visibleSlide) visibleSlide = container.querySelector('.swiper-slide');
    if (!visibleSlide) return;
    const visibleImage = visibleSlide.querySelector('img[data-media-id]');
    if (!visibleImage || imageMatches(visibleImage, mediaId)) return;
    visibleImage.removeAttribute('srcset');
    visibleImage.setAttribute('src', fullSrc);
    visibleImage.setAttribute('data-media-id', mediaId);
    const opener = visibleSlide.querySelector('lightbox-opener');
    if (opener) opener.setAttribute('data-media-id', mediaId);
  }
  function selectMedia(thumb) {
    const container = thumb.closest('swiper-slider-container');
    if (!container) return;
    const mediaId = thumb.getAttribute('data-media-id');
    const slider = container.querySelector('swiper-slider');
    if (!mediaId || !slider) return;
    container.querySelectorAll('.swiper-thumb.active').forEach(function (item) {
      item.classList.remove('active');
    });
    thumb.classList.add('active');
    const wrapper = slider.querySelector('.swiper-wrapper');
    const slides = wrapper ? Array.from(wrapper.children).filter(function (item) {
      return item.classList.contains('swiper-slide');
    }) : [];
    const index = slides.findIndex(function (slide) {
      const media = slide.querySelector('[data-media-id]');
      return media && media.getAttribute('data-media-id') === mediaId;
    });
    if (index >= 0 && slider.swiper && typeof slider.swiper.slideTo === 'function') {
      if (typeof slider.swiper.update === 'function') slider.swiper.update();
      slider.swiper.slideTo(index, 0, true);
      if (typeof slider.swiper.updateAutoHeight === 'function') slider.swiper.updateAutoHeight(0);
    }
    window.setTimeout(function () {
      const activeImage = container.querySelector('.swiper-slide-active img[data-media-id]');
      if (!imageMatches(activeImage, mediaId)) setVisibleImage(container, thumb, mediaId);
    }, 80);
  }
  document.addEventListener('click', function (event) {
    const thumb = event.target.closest('.product--thumbnail_slider .swiper-thumb, .product--thumbnail_slider__mobile .swiper-thumb');
    if (!thumb) return;
    event.preventDefault();
    event.stopPropagation();
    selectMedia(thumb);
  }, true);
})();